import { StringMap, Callback } from '../types';

export interface IEventEmitter {
  subscribe(event: string, callback: Callback): void;
  unsubscribe(event: string, callback: Callback): void;
  emit(event: string, params?: any): void;
}

export class EventEmitter implements IEventEmitter {
  private events: StringMap<Callback[]> = {};

  subscribe(event: string, callback: Callback): void {
    if (!this.events[event]) {
      this.events[event] = [];
    }

    this.events[event].push(callback);
  }

  unsubscribe(event: string, callback: Callback): void {
    this.events[event] = this.events[event].filter(eventCallback => callback !== eventCallback);
  }

  emit(event: string, params?: any): void {
    if (this.events[event]) {
      this.events[event].forEach(callback => callback.call(null, params));
    }
  }
}
